import { render, staticRenderFns } from "./tenMinutes.vue?vue&type=template&id=1f993da2&"
import script from "./tenMinutes.vue?vue&type=script&lang=js&"
export * from "./tenMinutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports